export const ELEMENT_TYPES = {
    TYPE_DOOR: 'door',
    TYPE_WINDOW: 'window',
    TYPE_BEAM: 'beam', // Unterzug
    TYPE_JUT: 'jut', // Vorsprung
    TYPE_PLINTH: 'plinth', // Sockel
    TYPE_WALL_CHEST: 'wall_chest', // Wandverkofferung
    TYPE_WALL_RECESS: 'wall_recess', // Wandnische
    TYPE_PIER: 'pier', // Stütze
    TYPE_ROUND_PIER: 'round_pier', // Rundstütze
    TYPE_MOULDING: 'moulding', // Deckenfr
    TYPE_WINDOW_SILL: 'window_sill', //Fensterbank
    TYPE_SOFFIT: 'soffit', // Laibung
    TYPE_CORNER_CASE: 'corner_case', // Eckkoffer
    TYPE_WALL_CENTER_CASE: 'wall_center_case', // Wand-Mittelkoffer
    TYPE_BEAM_CEILING_CASE: 'beam_ceiling_case', // Unterzug/Deckenkoffer
    TYPE_CENTER_BEAM_CEILING_CASE: 'center_beam_ceiling_case', // Mittel-Unterzüge/Deckenkoffer
    TYPE_TUBE: 'tube', // Rohr
    TYPE_FRAME: 'frame', //Zarge
    TYPE_TRAPEZOID: 'trapezoid', //Trapez
};

export const USER_ROLES = {
    USER: 'user',
    ADMIN: 'admin',
    FOREMAN: 'foreman',
    CONSTRUCTION_MANAGER: 'construction_manager'
};

export const PROJECT_STATUSES = {
    CREATED : 'created',
    MEASUREMENT : 'measurement',
    MEASUREMENT_COMPLETED : 'measurement_completed',
    MEASUREMENT_REALIZATION : 'realization',
    ARCHIVED : 'archived',
};


export const SUBTRACTION_MODES = {
    AUTO : 0,
    NEVER : 1,
    ALWAYS : 2,
};


export const DISABILITY_TYPES = {
    TYPE_CONCERN_PAINTERS: 'concern_painters',
    TYPE_CONCERN_EIFS: 'concern_eifs',
    TYPE_DISABILITY_PAINTERS: 'disability_painters',
    TYPE_DISABILITY_EIFS: 'disability_eifs',
};


export const STAFF_MEMBER_ROLES = {
    STAFF_MEMBER: 'staff_member',
    AGENCY_WORKER: 'agency_worker',
    SUBCONTRACTOR: 'subcontractor',
};

export const WALL_TYPES = {
    WALL: 'wall',
    GROUND: 'ground',
    CEILING: 'ceiling',
    PIER: 'pier',
    ROUND_PIER: 'round_pier',
    TRAPEZOID: 'trapezoid',
};

export const REVISION = {
    START_OF_DAY : 'day_start',
    END_OF_DAY : 'day_end',
}

export const OVERRIDE_NO = 'override_no';
export const OVERRIDE_ALL = 'override_all';
export const OVERRIDE_DEPENDENCIES = 'override_only_dependencies';

export const DUPLICATE_WITH_SERVICES = 'withServices';
export const DUPLICATE_WITH_ELEMENTS = 'withElements';
export const DUPLICATE_CLONE_FOUNDATION = 'cloneFoundation';
export const DUPLICATE_CLONE_ELEMENTS = 'cloneElements';
